/**
 * Firebase Read Counter - Actually count Firebase reads
 * Add this to any file that queries Firebase to see exact read counts
 */

let readCount = 0;
let readDetails = [];

export const countReads = {
  reset() {
    readCount = 0;
    readDetails = [];
    console.log('🔄 Firebase read counter reset');
  },

  increment(operation, count = 1, details = {}) {
    readCount += count;
    readDetails.push({
      operation,
      count,
      timestamp: new Date().toISOString(),
      ...details
    });

    console.log(`📊 Firebase Reads: ${readCount} total (+${count} from ${operation})`);

    // Alert on high reads
    if (readCount > 100 && readCount % 100 === 0) {
      console.warn(`⚠️ HIGH READ COUNT: ${readCount} reads!`);
      this.report();
    }
  },

  report() {
    console.group('📊 Firebase Read Report');
    console.log(`Total Reads: ${readCount}`);

    // Group by operation
    const byOperation = {};
    readDetails.forEach(detail => {
      const key = detail.operation;
      byOperation[key] = (byOperation[key] || 0) + detail.count;
    });

    console.table(byOperation);
    console.groupEnd();

    return { total: readCount, byOperation, details: readDetails };
  },

  getCount() {
    return readCount;
  }
};

// Make it global for easy access
if (typeof window !== 'undefined') {
  window.firebaseReadCount = countReads;
}